<template>
    <div>
        <HeaderContent header="คำสั่งซื้อ" :img_header="header_image" link_back="content" />
        <MenuContentPurchase/>
        <ContentReportList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/box.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentPurchase from '@/components/menuadmin/content/contentpurchase/MenuContentPurchase.vue'
import ContentReportList from '@/components/menuadmin/content/contentpurchase/ContentReportList.vue'

export default {
    name:'contentReport',
    components:{
        HeaderContent,
        MenuContentPurchase,
        ContentReportList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>